// Eğer bir sebepten ötürü ParentMessenger nesnesi yaratılmaz ise
//   ... ( Örneğin sayfaya iframe aracılığı ile değilde doğrudan Tarayıcıdan erişmek veya targetOriginin eşleşmemesi gibi )
// İletişim en başından itibaren bloke olur
// Eğer bir sorun olmaz ve yaratılır ise
//   ... ParentMessenger Nesnesi Yaratıldıktan Sonra
//   ... ParentMessenger.sendMessage( MESAJ_ADI as string, MESAJ_VERISI as object ) şeklinde kullanıma hazırdır
//   ... MESAJ_ADI
//           Şu an tanımlı olan 'resize' gibi sayfanın boyutsal bilgilerini iletmek amacı ile kullanılan string bir tanımdır.
//   ... MESAJ_VERISI
//          { key: value }, ['Bir', 'dizi'], 'veya string' gibi temel konteyner sınıflarının dışında herhangi kompleks bir nesne olamaz,
//          örneğin, bir HTMLAnchorElement nesne kopyası olamaz.

if ( ParentMessenger != null ) {

    // Boyut Bilgilerini Top Frame'e iletmek için bu fonksiyonu kendi başına çağırabilir veya bir event a kaydettirebiliriz
    function SendDimensionInformation () {
        ParentMessenger.sendMessage('resize', {
            bodyHeight: document.body.offsetHeight,
            bodyWidth: document.body.offsetWidth,
            outerWidth: window.outerWidth,
            outerHeight: window.outerHeight,
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight
        });
    }

    // Sayfa yüklendiğinde veya yeniden boyutlandırıldığında boyut bilgilerini Top Frame'e iletelim
    $(window).on('load resize', SendDimensionInformation);

    // -> implementation of [data-send-message-to-parent]
    $('body').on('click', '[data-send-message-to-parent]', function (e) {
        var script = $(this).data('process');
        var func   = new Function('return ' + script ).bind($(item));
        var data   = func();
        if ( typeof data == 'undefined' || data == null ||
             typeof data.name == 'undefined' || typeof data.message == 'undefined') return;
        ParentMessenger.sendMessage(data.name, data.message);
    });

    // Bootstrap Tab Değiştiğinde Tab İçeriği değişeceği ve dolayısı ile sayfa boyutu değişeceği için Top Frame'e yeni boyutları iletelim
    $('a[data-toggle="tab"]').on('shown', SendDimensionInformation);

    // Başka sayfa boyutunun değişmesine sebep olabilecek, aksiyonları tanımlamamız gerekmekte
    // Örneğin
    /*
        $('#ShowContent').on('click', SendDimensionInformation);

        //   #ShowContent isimli elementin sayfa içerisinde normalde gizli olan bir şeyi açığa
        //   çıkardığını varsayıyoruz, bu durumda sayfa yüksekliği değişeceği için Top Frame'in bu değişiklikten
        //   haberdar olması gerekmektedir, aksi takdirde tasarımsal sorunlar açığa çıkacaktır.
        //
        //   Her hangi bir konuda bilgi almak için 'arzu.ergin@ph.com.tr' adresinden Arzu Hanım ile iletişime geçebilirsiniz.
    */
}